import { SVGProps } from 'react'

const SvgHydricPotential = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path d='M12.001 6.466A10.014 10.014 0 0 0 2 16.468h1.498a8.502 8.502 0 0 1 17.003 0H22A10.014 10.014 0 0 0 12 6.466h.001zm0 3.075a6.935 6.935 0 0 0-6.929 6.927h1.04A5.893 5.893 0 0 1 12 10.579h.065l.639-1.004A6.622 6.622 0 0 0 12 9.54zm1.572 1.007-2.889 4.666a1.48 1.48 0 1 0 2.704.818l.185-5.484z' />
  </svg>
)

export default SvgHydricPotential
